import { render, staticRenderFns } from "./messageList2.vue?vue&type=template&id=10bb6ad0&scoped=true"
import script from "./messageList2.vue?vue&type=script&lang=js"
export * from "./messageList2.vue?vue&type=script&lang=js"
import style0 from "./messageList2.vue?vue&type=style&index=0&id=10bb6ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb6ad0",
  null
  
)

export default component.exports